import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { getFontURL } from 'src/utils/getFontUrl';
import { trackingList } from 'src/utils/valueHTML';

const FullContdown: FC = () => {
  let ClientName = useSelector((state: RootState) => state.client.userCompany);
  let templateId = useSelector((state: RootState) => state.template.templateId);
  let bg = useSelector((state: RootState) => state.imageUpload.bg);
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  let deeplink = useSelector((state: RootState) => state.imageUpload.deeplink);
  let radius = useSelector((state: RootState) => state.imageUpload.radius);

  let text = useSelector((state: RootState) => state.editText.text);
  let fontSize = useSelector((state: RootState) => state.editText.fontSize);
  let fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  let color = useSelector((state: RootState) => state.editText.color);
  let fontFamily = useSelector((state: RootState) => state.editText.fontFamily);
  let textAlign = useSelector((state: RootState) => state.editText.textAlign);

  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  let btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  let btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  let btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  let btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  let btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  let btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  let btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  let tracking = useSelector((state: RootState) => state.trackings.tracking);
  let button1 = useSelector((state: RootState) => state.trackings.button1);
  let button2 = useSelector((state: RootState) => state.trackings.button2);

  const yearTitleFontURL = getFontURL(fontFamily?.year_title);
  const titleFontURL = getFontURL(fontFamily?.title);
  const subTitleFontURL = getFontURL(fontFamily?.sub_title);
  const countdownTitleFontURL = getFontURL(fontFamily?.countdown_title);
  const countdownFontURL = getFontURL(fontFamily?.countdown);
  const btnFontURL = getFontURL(btnFontFamily?.button);
  // const yearTitleFontURL = `https://workspace.inappmessage.com/${ClientName}/font/${fontFamily?.year_title}`;
  // const titleFontURL = `https://workspace.inappmessage.com/${ClientName}/font/${fontFamily?.title}`;
  // const subTitleFontURL = `https://workspace.inappmessage.com/${ClientName}/font/${fontFamily?.sub_title}`;
  // const countdownTitleFontURL = `https://workspace.inappmessage.com/${ClientName}/font/${fontFamily?.countdown_title}`;
  // const countdownFontURL = `https://workspace.inappmessage.com/${ClientName}/font/${fontFamily?.countdown}`;
  // const btnFontURL = `https://workspace.inappmessage.com/${ClientName}/font/${btnFontFamily?.button}`;

  const closeImageUrl = 'https://i.ibb.co/xC9Gcwb/Frame-6.png';
  const style = `
  @font-face {
    font-family: 'yearTitleFont';
    src: url(${yearTitleFontURL});
    }
  @font-face {
    font-family: 'titleFont';
    src: url(${titleFontURL});
    }
  @font-face {
    font-family: 'subTitleFont';
    src: url(${subTitleFontURL});
    }
  @font-face {
    font-family: 'countdownTitleFont';
    src: url(${countdownTitleFontURL});
    }
  @font-face {
    font-family: 'countdownFont';
    src: url(${countdownFontURL});
    }
  @font-face {
    font-family: 'btnFont';
    src: url(${btnFontURL});
    }

    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      ${
        bg === 'image'
          ? `background-image: url(${bgImage?.background});`
          : `background: ${bgColor?.background};`
      };
      width: 100%;
      height: 100%;

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      position: relative;
    }
    .content_wrapper {
      width: 100%;
      height: 100%;
      padding: 0 10%;
    }

    .close_btn {
      position: absolute;
      right: 10%;
      top: 6%;
    }
    .close_btn button {
      width: 1.5rem;
      height: 1.5rem;
      
      background-image: url(${closeImageUrl});
      background-repeat: no-repeat;
      background-size: 1.5rem;
      background-position: center;

      font-size: 0;
      border: none;
      background-color: transparent;
    }
    
    .center {
      width: 100%;
      height: 100%;
      
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 0.5rem;
    }

    .title_wrapper {
      width: 100%;
      display: flex;

      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 0.5rem;
    }
    .title_wrapper .year {
      width: 100%;
      height: 1.25rem;
      text-align: ${textAlign?.year_title};

      font-size: ${fontSize?.year_title}rem;
      font-weight: ${fontWeight?.year_title};
      color: ${color?.year_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.year_title
        )
          ? fontFamily?.year_title
          : 'yearTitleFont'
      } !important;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .title_wrapper .title {
      width: 100%;
      height: 3rem;
      text-align: ${textAlign?.title};
      
      font-size: ${fontSize?.title}rem;
      font-weight: ${fontWeight?.title};
      color: ${color?.title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.title
        )
          ? fontFamily?.title
          : 'titleFont'
      } !important;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .title_wrapper .sub_title {
      width: 100%;
      height: 4rem;
      text-align: ${textAlign?.sub_title};

      font-size: ${fontSize?.sub_title}rem;
      font-weight: ${fontWeight?.sub_title};
      color: ${color?.sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.sub_title
        )
          ? fontFamily?.sub_title
          : 'subTitleFont'
      } !important;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
    }

    .timer_area {
      width: 100%;
      display: flex;

      flex-direction: column;
      gap: 0.5rem;
    }
    .timer_area .countdown_text {
      width: 100%;
      height: 1.5rem;
      text-align: ${textAlign?.countdown_title};

      font-size: ${fontSize?.countdown_title}rem;
      font-weight: ${fontWeight?.countdown_title};
      color: ${color?.countdown_title};
     
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.countdown_title
        )
          ? fontFamily?.countdown_title
          : 'countdownTitleFont'
      } !important;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .timer_area .timer {
      height: 6.25rem;

      display: grid;
      grid-template-columns: 1fr 1rem 1fr 1rem 1fr;
      justify-content: space-between;
    }
    .timer_area li {
      list-style: none;
      text-align: ${textAlign?.countdown};

      font-size: ${fontSize?.countdown}rem;
      font-weight: ${fontWeight?.countdown};
      color: ${color?.countdown};
      font-family: ${fontFamily?.countdown} !important;
    }
    .timer_area .en {
      display: block;
      font-size: 1.25rem;
      font-weight: 400;
      font-family: ${fontFamily?.countdown} !important;
    }
    .timer_area .finish_ment {
      height: 5rem;

      display: flex;
      justify-content: center;
      align-items: center;

      white-space: pre-line;
      font-size: 1.25rem;
      font-weight: ${btnFontWeight?.sub_button};
      color: ${color?.countdown};
    }

    .btn_bottom {
      width: 100%;
      padding: 0 10%;
      position: absolute;
      left: 0;
      bottom: 48px;
    }
    .btn_bottom button {
      width: 100%;
      height: 3rem;
      padding: 0 1rem;
      border: none;
      display: block;
      text-align: center;
    }
    .btn_bottom .style01 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      cursor: pointer;
      font-size: ${btnFontSize?.button}rem;
      font-weight: ${btnFontWeight?.button};
      color: ${btnColor?.button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.button
        )
          ? btnFontFamily?.button
          : 'btnFont'
      } !important;
      border-radius: ${radius?.button}px;
      background-color:rgba(${btnBgColorR?.button},${btnBgColorG?.button}, ${
    btnBgColorB?.button
  }, ${btnBgColorA?.button});
     }

    @media screen and (min-width: 608px) and (max-width: 1024px) {
      .content_wrapper {
        padding: 0 25%;
      }
      .close_btn {
        right: 25%;
        top: 4rem;
      }

      .title_wrapper,
      .timer_area,
      .center {
        gap: 1rem;
      }
      .title_wrapper .year {
        height: 1.8125rem;
        font-size: ${fontSize?.year_title + 0.5}rem;
      }
      .title_wrapper .title {
        height: 4rem;
        font-size: ${fontSize?.title + 1}rem;
      }
      .title_wrapper .sub_title {
        height: 5rem;
        font-size: ${fontSize?.sub_title + 1}rem;
        -webkit-line-clamp: 2;
      }

      .timer_area .timer {
        height: 8.125rem;
      }
      .timer_area .countdown_text {
        height: 2rem;
        font-size: ${fontSize?.countdown_title + 0.5}rem;
      }
      .timer_area li {
        font-size: ${fontSize?.countdown + 1.5}rem;
      }

      .btn_bottom {
        padding: 0 25%;
        bottom: 4rem;
      }
      .btn_bottom button {
        height: 4rem;
      }
    }
  `;

  const html = `
    <div class="root" id="test">
      <div className="content_wrapper">
        <div class="close_btn">
          <button class="close_btn_icon">close</button>
        </div>

        <div class="center">
          <div class="title_wrapper">
            <p class="year">${changeEnterHTML(text?.year_title)}</p>
            <h2 class="title">${changeEnterHTML(text?.title)}</h2>
            <p class="sub_title">${changeEnterHTML(text?.sub_title)}</p>
          </div>

          <div class="timer_area">
            <p class="countdown_text">${changeEnterHTML(
              text?.countdown_title
            )}</p>
            <ul class="timer" id="timer">
              <li>
                <div id="cDay" class="time">00</div>
                <div class="en">Hours</div>
              </li>
              <li class="margin">:</li>
              <li>
                <div id="cHour" class="time">00</div>
                <div class="en">Mins</div>
              </li>
              <li class="margin">:</li>
              <li>
                <div id="cMin" class="time">00</div>
                <div class="en">Secs</div>
              </li>
            </ul>
          </div>
        </div> 

        <div class="btn_bottom">
          <button class="style01">
            ${btnText?.button}
          </button>
        </div>
      </div>
    </div>
  `;

  let tracking_list = `[`;
  for (let i = 0; i < tracking?.background?.length; i++) {
    tracking_list += `['${tracking?.background?.[i]}', '${tracking?.button?.[i]}'],`;
  }
  tracking_list += ']';

  let tracking_button_list = trackingList(
    'BASIC FULL COUNTDOWN',
    button1,
    button2
  );

  const js = `
  document.addEventListener("DOMContentLoaded", function(){
    let id = '${templateId}';
    
    const countdownTimer = function (id1, id2, id3, id4, date) {
      let _vData = date;
      let timer;
  
      function showRemaining() {
        let now = new Date();
        let distDt = _vData - now;

        if (distDt < 0) {
          clearInterval(timer);
          document.getElementById(id4).textContent = "종료되었습니다.";
          $(".timer").addClass("finish_ment");
          return;
        }
  
        let days = Math.floor(distDt / (1000 * 60 * 60 * 24));
        let hours = Math.floor(distDt / (1000 * 60 * 60));
        let minutes = Math.floor(distDt / (1000 * 60));
        let seconds = Math.floor(distDt / 1000);

        let d = days;
        let h = hours - days * 24;
        let m = minutes - hours * 60;
        let s = seconds - minutes * 60;

        let date = h + d * 24;
        document.getElementById(id1).textContent = date;
        document.getElementById(id2).textContent = m;
        document.getElementById(id3).textContent = s;
      }
  
      timer = setInterval(showRemaining, 1000)
    }

    countdownTimer("cDay", "cHour", "cMin", "timer", new Date(${
      text?.countdown?.year
    },${text?.countdown?.month - 1},${text?.countdown?.date},${
    text?.countdown?.hour
  },${text?.countdown?.min}))
    
      $(function () {
        try {
          // 맨 처음 impression log
          let json = {
            template_id : id,
            event : 'impression',
            iam_type : 'FullCountDown'
          }
          $.ajax({
            url : "https://njm2ndrjm8.execute-api.ap-northeast-2.amazonaws.com/api/eventlog/${ClientName}",
            method : "PATCH",
            crossOrigin : true,
            data : JSON.stringify(json),
            contentType: "application/json; charset=utf-8"
          })
        } catch (error) {
          console.error("Error Logging impression(full countdown): ", error);
        }
      });

      $(".content_body").on("click", function () {
        let json = {
          template_id : id,
          area : 'button',
          event : 'click',
          iam_type : 'FullCountDown'
        }
        fetch('https://njm2ndrjm8.execute-api.ap-northeast-2.amazonaws.com/api/eventlog/${ClientName}', {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
          },
          mode : 'cors',
          keepalive : true,
          body: JSON.stringify(json)
        });
      });

      let tracking = ${tracking_list};
      let button1 = ${tracking_button_list[0]};
      let button2 = ${tracking_button_list[1]};
      $('.close_btn_icon').click(function() {
        appboyBridge.logClick(tracking[0][1]);
        try {
          if (button1[1].indexOf(0) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[1].indexOf(0) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        appboyBridge.closeMessage();
      });
      $('.style01').click(function() {
        appboyBridge.logClick(tracking[0][0]);
        try {
          if (button1[0].indexOf(0) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[0].indexOf(0) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        window.location = '${deeplink?.background}';
      });
    });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          http-equiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta http-equiv="Expires" content="0" />
        <meta http-equiv="Pragma" content="no-cache" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <style dangerouslySetInnerHTML={{ __html: style }}></style>
        <script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.js"></script>
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }}></body>
      <script dangerouslySetInnerHTML={{ __html: js }}></script>
    </>
  );
};
export default FullContdown;
